// recuperacao-01 — textos da campanha de recuperação (tradução à mão, pt → es)
const catalogo: Record<string, string> = {
    "Não foi possível calcular a contagem.": "No fue posible calcular el conteo.",
    "Cadastre um desconto do tipo Recuperação para simular.": "Registre un descuento del tipo Recuperación para simular.",
    "Complete o nome, desconto e duração de cada nível para simular.": "Complete el nombre, descuento y duración de cada nivel para simular.",
    "Ajuste a faixa de dias sem abastecer.": "Ajuste el rango de días sin cargar combustible.",
    "O 'até' precisa ser maior que o 'a partir de'.": "El 'hasta' debe ser mayor que el 'a partir de'.",
    "Limite de clientes não pode passar de 200.000.": "El límite de clientes no puede superar los 200.000.",
    "Cada nível precisa de nome, desconto e duração.": "Cada nivel necesita nombre, descuento y duración.",
    "Cada nível precisa de um desconto diferente.": "Cada nivel necesita un descuento diferente.",
    "O nível 1 precisa de título e mensagem para enviar notificação.": "El nivel 1 necesita título y mensaje para enviar notificación.",
    "{{nome_do_cliente}} só funciona no push; desligue o SMS ou tire o nome da mensagem": "{{nome_do_cliente}} solo funciona en el push; apague el SMS o quite el nombre del mensaje",
    "Criar Campanha de Recuperação": "Crear Campaña de Recuperación",
    "Nome da campanha": "Nombre de la campaña",
    "Público": "Público",
    "Orçamento": "Presupuesto",
    "Revisão": "Revisión",
    "Campanha criada e iniciada": "Campaña creada e iniciada",
    "Nível atual": "Nivel actual",
    "Campanhas de Recuperação": "Campañas de Recuperación",
    "Fim previsto": "Fin previsto",
    "Trazidos": "Traídos",
    "Auditoria": "Auditoría",
    "Campanha de Recuperação": "Campaña de Recuperación",
    "Finalizar agora": "Finalizar ahora",
    "Este é o último nível. Finalizar agora encerra a campanha e apaga os cupons dos clientes que não voltaram.": "Este es el último nivel. Finalizar ahora cierra la campaña y borra los cupones de los clientes que no volvieron.",
    "%{arg1} cliente(s) ativos afetados": "%{arg1} cliente(s) activos afectados",
    "Avançar": "Avanzar",
    "Quem entra na campanha é decidido agora. O público não muda depois de criada.": "Quién entra en la campaña se decide ahora. El público no cambia después de creada.",
    "Segmento": "Segmento",
    "Dias sem abastecer (a partir de)": "Días sin cargar combustible (a partir de)",
    "Até (dias)": "Hasta (días)",
    "Sem teto de dias (inclui quem parou há muito tempo)": "Sin techo de días (incluye a quien dejó de cargar hace mucho tiempo)",
    "Incluir quem nunca abasteceu (ativação não é recuperação — use com cuidado)": "Incluir a quien nunca cargó combustible (activación no es recuperación — use con cuidado)",
    "Etiquetas (qualquer uma delas)": "Etiquetas (cualquiera de ellas)",
    "Selecione": "Seleccione",
    "Sem limite de clientes": "Sin límite de clientes",
    "Limite de clientes (prioriza quem parou há menos tempo)": "Límite de clientes (prioriza a quien dejó de cargar hace menos tiempo)",
    "Contagem ao vivo": "Conteo en vivo",
    "%{arg1} com app": "%{arg1} con app",
    "%{arg1} com celular": "%{arg1} con celular",
    "Nenhum cliente no público. Ajuste os filtros antes de continuar.": "Ningún cliente en el público. Ajuste los filtros antes de continuar.",
    "Ajuste os filtros para ver a contagem.": "Ajuste los filtros para ver el conteo.",
    "Sem eventos ainda.": "Sin eventos todavía.",
    "Carregar mais": "Cargar más",
    "Teto opcional de gasto com desconto. Ao atingir, a campanha encerra antes do fim — o sistema confere a cada 15 minutos, então pode passar um pouco do teto entre uma checagem e outra.": "Techo opcional de gasto con descuento. Al alcanzarlo, la campaña se cierra antes del fin — el sistema revisa cada 15 minutos, así que puede pasar un poco del techo entre una revisión y otra.",
    "Sem teto de gasto": "Sin techo de gasto",
    "Regra do modelo antigo, encerrada na migração para campanhas.": "Regla del modelo antiguo, cerrada en la migración a campañas.",
    "running": "running",
    "Criada por": "Creada por",
    "em": "en",
    "cancelled": "cancelled",
    "Finalizada": "Finalizada",
    "por": "por",
    "Os cupons dos clientes que ainda não voltaram são apagados e a campanha para de mandar mensagem.": "Los cupones de los clientes que aún no volvieron se borran y la campaña deja de enviar mensajes.",
    "%{arg1}/%{arg2} — mínimo de %{arg3} caracteres": "%{arg1}/%{arg2} — mínimo de %{arg3} caracteres",
    "Campanha encerrada": "Campaña cerrada",
    "Nível da volta": "Nivel de la vuelta",
    "Usou cupom": "Usó cupón",
    "Valor da volta": "Valor de la vuelta",
    "Inscrito em": "Inscrito en",
    "Todos os clientes avançam juntos. Cada nível dura os dias definidos e depois avança (ou encerra a campanha, no último nível).": "Todos los clientes avanzan juntos. Cada nivel dura los días definidos y después avanza (o cierra la campaña, en el último nivel).",
    "Nenhum desconto do tipo Recuperação disponível nesta rede. Cadastre um em Descontos antes de continuar.": "Ningún descuento del tipo Recuperación disponible en esta red. Registre uno en Descuentos antes de continuar.",
    "Nome do nível": "Nombre del nivel",
    "Desconto de recuperação": "Descuento de recuperación",
    "Título da mensagem": "Título del mensaje",
    "Atual": "Actual",
    "Duração planejada:": "Duración planeada:",
    "Voltas": "Vueltas",
    "Com cupom": "Con cupón",
    "Sem métricas ainda.": "Sin métricas todavía.",
    "Ainda na campanha": "Aún en la campaña",
    "Não voltaram": "No volvieron",
    "Trazidos pela campanha (com cupom)": "Traídos por la campaña (con cupón)",
    "Voltaram sem cupom": "Volvieron sin cupón",
    "Custo por cliente trazido": "Costo por cliente traído",
    "Orçamento usado": "Presupuesto usado",
    "Receita da volta": "Ingreso de la vuelta",
    "Receita em 30 dias depois da volta": "Ingreso en 30 días después de la vuelta",
    "Receita por R$ de desconto": "Ingreso por R$ de descuento",
    "Nenhum desconto selecionado": "Ningún descuento seleccionado",
    "Duração total": "Duración total",
    "Termina em": "Termina en",
    "Canais": "Canales",
    "Assim que possível": "Lo antes posible",
    "Duração": "Duración",
    "Criar e iniciar campanha": "Crear e iniciar campaña",
    "Criar e iniciar campanha?": "¿Crear e iniciar campaña?",
    "A campanha não pode ser editada depois. Ela começa agora e termina em": "La campaña no puede editarse después. Empieza ahora y termina en",
    "{{nome_do_cliente}} só funciona no push; desligue o SMS ou tire o nome da mensagem dos níveis.": "{{nome_do_cliente}} solo funciona en el push; apague el SMS o quite el nombre del mensaje de los niveles.",
    "Horário de envio (BRT)": "Horario de envío (BRT)",
    "Em branco: envia assim que possível, a cada troca de nível.": "En blanco: envía lo antes posible, en cada cambio de nivel.",
    "Complete o público e os níveis para ver a simulação.": "Complete el público y los niveles para ver la simulación.",
    "Simulação": "Simulación",
    "%{arg1} clientes": "%{arg1} clientes",
    "Estimativa a partir dos últimos": "Estimación a partir de los últimos",
    "dias da rede: ticket médio": "días de la red: ticket promedio",
    "litros por abastecimento (": "litros por carga de combustible (",
    "abastecimentos no período).": "cargas de combustible en el período).",
    "Se voltarem": "Si vuelven",
    "Custo estimado": "Costo estimado",
    "Receita estimada": "Ingreso estimado",
    "Orçamento acaba em": "El presupuesto se acaba en",
    "Taxa livre:": "Tasa libre:",
    "Estimativa: supõe que todo cliente que volta usa o cupom. O custo real depende de quantos usam de fato.": "Estimación: supone que todo cliente que vuelve usa el cupón. El costo real depende de cuántos lo usan de verdad.",
    "Campanha criada": "Campaña creada",
    "(automático)": "(automático)",
    "Nível iniciado": "Nivel iniciado",

    // "Gerar com IA" da mensagem do nível (messageSuggestion.ts no backend).
    "Mensagem da notificação": "Mensaje de la notificación",
    "Gerar com IA": "Generar con IA",
    "Gerando…": "Generando…",
    "Isso substitui o título e a mensagem já preenchidos deste nível. Continuar?": "Esto reemplaza el título y el mensaje ya completados de este nivel. ¿Continuar?",
    "Sugestão gerada — revise antes de salvar.": "Sugerencia generada — revísela antes de guardar.",
    "Não foi possível gerar a sugestão agora.": "No fue posible generar la sugerencia ahora.",
    "Informe o gasto máximo ou marque 'Sem teto de gasto'.": "Informe el gasto máximo o marque 'Sin techo de gasto'.",
    "Campanhas de recuperação": "Campañas de recuperación",
    "Veja quantos clientes estão ativos, em risco ou inativos, filtre por etiqueta e crie uma campanha de recuperação já com o público certo selecionado.": "Vea cuántos clientes están activos, en riesgo o inactivos, filtre por etiqueta y cree una campaña de recuperación ya con el público correcto seleccionado.",
};

export default catalogo;
